import { render, staticRenderFns } from "./MemoryEnabledSection.vue?vue&type=template&id=296363c9&scoped=true"
import script from "./MemoryEnabledSection.vue?vue&type=script&lang=js"
export * from "./MemoryEnabledSection.vue?vue&type=script&lang=js"
import style0 from "./MemoryEnabledSection.vue?vue&type=style&index=0&id=296363c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296363c9",
  null
  
)

export default component.exports